import { useLocale } from '@mirai/locale';
import { Notification, Progress, styles, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { DEFAULT_LANGUAGE, SCRIPT_ID, SCRIPT_URL, SUPPORTED_LANGUAGES } from './FormReduniq.constants';
import { L10N } from './FormReduniq.l10n';
import * as style from './FormReduniq.module.css';
import { loadScript } from '../../../../../helpers/loadScript';

const CONTAINER_ID = 'reduniq-checkout';

export const FormReduniq = ({ response }) => {
  const { language, translate } = useLocale();

  const [error, setError] = useState();
  const [ready, setReady] = useState(false);

  const ref = useRef();

  useEffect(() => {
    let cleanup;

    (async () => {
      try {
        cleanup = await loadScript({
          domain: 'payments',
          id: SCRIPT_ID,
          src: SCRIPT_URL,
          onLoad: () => setReady(true),
        });
      } catch (nextError) {
        setError(nextError);
      }
    })();

    return () => {
      cleanup && cleanup();
    };
  }, []);

  const { configuration: { urlPath } = {} } = response || {};
  const widgetLanguage = SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;

  return (
    <View className={style.container}>
      <Progress indeterminate visible={!ready && !error} />
      <View
        {...{
          'rpg-config': JSON.stringify({ language: widgetLanguage }),
          'rpg-style': JSON.stringify({ iframe: { scrolling: 'no' } }),
          'rpg-url-path': urlPath,
        }}
        id={CONTAINER_ID}
        ref={ref}
        className={styles('rpg-widget-iframe', style.checkout)}
      />
      {error && (
        <Notification error small wide>
          {translate(L10N.NOTIFICATION_ERROR)}
        </Notification>
      )}
    </View>
  );
};

FormReduniq.displayName = 'Mirai:Payments:ButtonPayment:FormReduniq';

FormReduniq.propTypes = {
  response: PropTypes.shape({
    configuration: PropTypes.shape({
      urlPath: PropTypes.string,
    }),
  }),
};
